import { render, staticRenderFns } from "./LoanIndex.vue?vue&type=template&id=20008149&scoped=true"
import script from "./LoanIndex.vue?vue&type=script&lang=js"
export * from "./LoanIndex.vue?vue&type=script&lang=js"
import style0 from "./LoanIndex.vue?vue&type=style&index=0&id=20008149&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20008149",
  null
  
)

export default component.exports